import getISODay from 'date-fns/get_iso_day';

/**
 * @description день недели даты в формате ISO, 1..7.
 * @note 'YYYY-MM-DD' парсится как UTC-полночь, поэтому в отрицательных
 * таймзонах день сместится назад на сутки. На сравнение «основной инвойс vs
 * цикл» это не влияет: обе даты приводятся одним и тем же способом
 */
export const getWeekday = (date) => getISODay(new Date(date));

const getTimeParts = (value) => {
    const [hour, minute] = String(value || '').split(':');
    return { hour: Number(hour), minute: Number(minute) };
};

/**
 * @description интервалы доставки, доступные в конкретный день недели
 */
export const getIntervalsForDate = (date, intervalsData) => {
    if (!intervalsData) return [];

    const {
        has_morning_deliveries: hasMorning,
        has_evening_deliveries: hasEvening,
        morning_intervals: morning = [],
        evening_intervals: evening = [],
        days_of_week_for_morning_delivery: morningDays = [],
        days_of_week_for_evening_delivery: eveningDays = [],
    } = intervalsData;

    const weekday = getWeekday(date) - 1;

    const morningForDay = hasMorning && morningDays[weekday] ? morning : [];
    const eveningForDay = hasEvening && eveningDays[weekday] ? evening : [];

    return [...morningForDay, ...eveningForDay]
        .map(({ time_from: timeFrom, time_to: timeTo }) => {
            const from = getTimeParts(timeFrom);
            const to = getTimeParts(timeTo);

            return {
                hour_from: from.hour,
                /* @note логика 23:00 из основного флоу, Checkout.js */
                hour_to: to.minute === 59 ? to.hour + 1 : to.hour,
            };
        })
        .sort((a, b) => a.hour_from - b.hour_from);
};

/**
 * @description даты с тем же днём недели, что и у основного инвойса, идут первыми:
 * клиенту нужен привычный день доставки, а не самая ранняя доступная дата.
 * Внутри групп порядок исходный — даты не перемешиваются
 */
export const prioritizeDatesByWeekday = (dates, baseDate) => {
    if (!baseDate) return dates;

    const baseWeekday = getWeekday(baseDate);

    return [
        ...dates.filter((date) => getWeekday(date) === baseWeekday),
        ...dates.filter((date) => getWeekday(date) !== baseWeekday),
    ];
};

/**
 * @description интервал, аналогичный основному инвойсу: сначала точное
 * совпадение по часам, затем с тем же началом, иначе первый доступный
 */
export const pickSimilarInterval = (intervals, baseTime) => {
    if (!baseTime) return intervals[0];

    const { hour_from: baseFrom, hour_to: baseTo } = baseTime;

    const sameInterval = intervals.find((interval) => (
        interval.hour_from === baseFrom && interval.hour_to === baseTo
    ));

    if (sameInterval) return sameInterval;

    const sameStart = intervals.find((interval) => interval.hour_from === baseFrom);

    return sameStart || intervals[0];
};

/**
 * @description интервал доставки в формате createInvoice из полей самой
 * доставки time_from/time_to, которые приходят в формате HHmm (1800, 2359)
 */
export const getDeliveryTimeInterval = (delivery) => {
    const timeFrom = delivery?.time_from;
    const timeTo = delivery?.time_to;

    if (typeof timeFrom !== 'number' || typeof timeTo !== 'number') return null;

    const hourTo = Math.floor(timeTo / 100);

    return {
        hour_from: Math.floor(timeFrom / 100),
        /* @note логика 23:00 из основного флоу, Checkout.js */
        hour_to: timeTo % 100 === 59 ? hourTo + 1 : hourTo,
    };
};
